export const getContentFieldClass = (data): string => {
  const classes = data?.class || data?.fields?.class || [];
  return classes.join(' ') || '';
};
